import type { VueHeadClient } from '@unhead/vue';
import { createPinia } from 'pinia';
import { type App } from 'vue';
import { type I18n, type LocaleMessages } from 'vue-i18n';

import { DEFAULT_LANGUAGE } from '@/i18n';
import { initI18n } from '@/i18n-setup';
import createAgencyRouter from '@/router';
import { createSplitStore, type SplitStoreState } from '@/splitExperiments/store';
import domus, { HgSupportedLanguage, type PluginOptions } from '@smg-real-estate/domus';
import { type Pinia } from 'pinia';
import { type Router } from 'vue-router';
import { type Store } from 'vuex';

type CreateHead = () => VueHeadClient;

export async function createAgencyApp(
  app: App,
  translations: LocaleMessages<never>,
  createHead: CreateHead,
): Promise<{
  app: App<Element>;
  router: Router;
  pinia: Pinia;
  store: Store<SplitStoreState>;
  head: VueHeadClient;
  i18n: I18n;
}> {
  const i18n = initI18n(translations);

  const router = createAgencyRouter(DEFAULT_LANGUAGE);
  const domusOptions: PluginOptions = {
    theme: import.meta.env.VUE_APP_BUILD_TARGET,
    i18n: { instance: i18n, languages: { name: 'all', mode: 'lazy' } },
    router: { instance: router, defaultLanguage: HgSupportedLanguage.EN },
  };

  const head = createHead();
  const pinia = createPinia();
  const store = createSplitStore();

  app.use(router);
  app.use(pinia);
  app.use(store);
  app.use(i18n);
  app.use(head);
  app.use(domus, domusOptions);

  return { app, router, pinia, store, head, i18n };
}
